export const PREFIXED_FUNCTION_WORDS = [ "ב", "ה", "ו", "כ", "ל", "מ", "ש" ];
export const PREFIXED_FUNCTION_WORDS_REGEX = new RegExp( `^(${PREFIXED_FUNCTION_WORDS.join( "|" )})` );
